module.exports = __webpack_public_path__ + "static/media/ComponentX.452e2deb.svg";